import React from 'react';
import { Text, View } from 'react-native';

import { adminTableMemberGridStyles } from './adminTableMemberGridStyles';
import { adminTableStyles } from './adminTableStyles';

export interface AdminTableNameEmailHeaderProps {
  trailingLabel: string;
  showActionsColumn?: boolean;
  trailingLabelAlign?: 'right' | 'center';
  children?: React.ReactNode;
}

/** Header row: primary column (search or empty) + trailing label (+ optional actions spacer). */
export const AdminTableNameEmailHeader: React.FC<
  AdminTableNameEmailHeaderProps
> = ({
  trailingLabel,
  showActionsColumn = false,
  trailingLabelAlign = 'right',
  children,
}) => (
  <View style={adminTableStyles.header}>
    <View style={adminTableMemberGridStyles.headerPrimary}>{children}</View>
    <Text
      style={[
        adminTableStyles.headerText,
        trailingLabelAlign === 'center'
          ? adminTableMemberGridStyles.trailingHeaderCentered
          : adminTableMemberGridStyles.trailingHeader,
      ]}
      numberOfLines={1}
    >
      {trailingLabel}
    </Text>
    {showActionsColumn ? (
      <View style={adminTableMemberGridStyles.actionsColumn} />
    ) : null}
  </View>
);
